import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Store } from "../Store";
import { formatBytes } from "../utils";

export default function BusinessUserStatsScreen() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { state } = useContext(Store);
  const { userInfo } = state;

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get("/api/logs/stats", {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        });
        setStats(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  return (
    <div className="container">
      <h1 className="my-3">İşletme Kullanıcı İstatistikleri</h1>
      {loading ? (
        <div>Yükleniyor...</div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Adı</th>
              <th>E-posta</th>
              <th>Telefon</th>
              <th>İşletme Adı</th>
              <th>Toplam İstek Sayısı</th>
              <th>Toplam Payload Boyutu</th>
              <th>Toplam Yanıt Boyutu</th>
              <th>Farklı IP Sayısı</th>
            </tr>
          </thead>
          <tbody>
            {stats.map((stat, index) => (
              <tr key={stat.businessUser?._id || index}>
                <td>{index + 1}</td>
                <td>{stat.businessUser?.name || stat.userId || "N/A"}</td>
                <td>{stat.businessUser?.email || "N/A"}</td>
                <td>{stat.businessUser?.phone || "N/A"}</td>
                <td>{stat.businessUser?.businessName || "N/A"}</td>
                <td>{stat.totalRequests}</td>
                <td>{formatBytes(stat.totalPayloadSize)}</td>
                <td>{formatBytes(stat.totalResponseSize)}</td>
                <td>{stat.distinctIPCount}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}
